export default __webpack_public_path__ + "static/media/img-3.dc2e6497.png";